import { Component, Input } from '@angular/core';

export type VwTone = 'indigo' | 'violet' | 'orange' | 'red' | 'green' | 'cyan' | 'gray' | 'yellow' | 'silver';

@Component({
  selector: 'app-status-badge',
  templateUrl: './status-badge.component.html',
  styleUrls: ['./status-badge.component.scss'],
})
export class StatusBadgeComponent {
  @Input() label: string;
  @Input() tone: VwTone = 'gray';
}
